module.exports = __webpack_public_path__ + "img/app_logo.15931002.png";